<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-fill-sound`]" width="1em" height="1em" v-bind="$attrs"><path d="M14 15l10-7v32l-10-7H6V15h8z"/><path d="M14 15v2a2 2 0 001.147-.361L14 15zm10-7h2a2 2 0 00-3.147-1.638L24 8zm0 32l-1.147 1.639A2 2 0 0026 40h-2zm-10-7l1.147-1.639A2 2 0 0014 31v2zM6 15v-2a2 2 0 00-2 2h2zm0 18H4a2 2 0 002 2v-2zm9.147-16.361l10-7-2.294-3.277-10 7 2.294 3.277zM22 8v32h4V8h-4zm3.147 30.361l-10-7-2.294 3.277 10 7 2.294-3.276zM6 17h8v-4H6v4zm8 14H6v4h8v-4zm-6 2V15H4v18h4zm21.657-14.586a8 8 0 010 11.314l2.828 2.828c4.687-4.686 4.687-12.284 0-16.97l-2.828 2.828zm5.657-6c6.248 6.249 6.248 16.38 0 22.628l2.828 2.828c7.81-7.81 7.81-20.474 0-28.284l-2.828 2.828z"/></svg>
</template>
<script>

export default {
  name: 'IconFillSound',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
